import React, { useState, useEffect } from "react";
import { Icon, Segment } from "semantic-ui-react";
import "scss/components/maintenance/maintenanceInform.scss";

export default function MaintenanceInform(props) {
  const [detail, setDetail] = useState(props?.order);
  // console.log(props?.order);

  useEffect(() => {
    setDetail(props?.order);
  });

  const onGetMonth = (month) => {
    const monthNames = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ];
    return monthNames[parseInt(month) - 1];
  };

  const contactDetail = () => {
    return (
      <table>
        <tbody>
          <tr>
            <td>
              <b>ชื่อ-นามสกุล ผู้ใช้งาน</b>&emsp;{detail?.userId}
            </td>
            <td>
              <b>เบอร์โทรศัพท์</b>&emsp;{detail?.phoneNo}
            </td>
          </tr>
          <tr>
            <td>
              <b>ที่อยู่</b>&emsp;{detail?.address}
            </td>
            <td>
              <b>ไอดีไลน์</b>&emsp;{detail?.email}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const deviceType = () => {
    return (
      <table>
        <tbody>
          <tr>
            <td>ประเภทเครื่องจักร</td>
            <td>
              <Icon name="check square" />
              ประเภทเครื่องจักร เครื่องสีข้าว,เครื่องคัดแยกเมล็ดพันธุ์ Model :
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <Icon name="square outline" />
              หางเรือ Model : __________________ความยาว____________cm.
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <Icon name="square outline" />
              เครื่องจักรกลทางการเกษตร Model :_________________
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const maintenanceDetail = () => {
    return (
      <table>
        <tbody>
          <tr>
            <td>
              <b>หมายเลขเครื่องจักร</b>&emsp;{detail?.clpSerial}
            </td>
            <td>
              <b>สถานะการรับประกันสินค้า</b>&emsp;
              {detail?.inWarranty === 1
                ? "อยู่ในการรับประกัน"
                : "ไม่อยู่ในการรับประกัน"}
            </td>
          </tr>
          <tr>
            <td>
              <b>วันที่เริ่มใช้/ระยะเวลาการใช้งาน</b>&emsp;
              {detail?.periodActiveRange}
            </td>
            <td>
              <b>วันที่พบปัญหา</b>&emsp;{detail?.problemDetectionDate}
            </td>
          </tr>
          <tr>
            <td>
              <b>ผู้รับแจ้ง</b>
            </td>
            <td>
              <b>วันที่แจ้งซ่อม (ปัญหา)</b>&emsp;
              {detail?.createAt && (
                <>
                  {detail?.createAt.substring(8, 10)}{" "}
                  {onGetMonth(detail?.createAt.substring(5, 7))}{" "}
                  {parseInt(detail?.createAt.substring(0, 4)) + 543}
                </>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <div className="maintenanceInform">
      <Segment>
        <div className="maintenanceInform-header"></div>
        <div className="maintenanceInform-content">
          <div className="maintenanceInform-content-date">
            <p>
              <b>เลขที่</b> {detail?.documentNo}
            </p>
            <p>
              {detail?.createAt && (
                <>
                  {detail?.createAt.substring(8, 10)}
                  &ensp;<b>เดือน</b>{" "}
                  {onGetMonth(detail?.createAt.substring(5, 7))}
                  &ensp;<b>ปี</b>{" "}
                  {parseInt(detail?.createAt.substring(0, 4)) + 543}
                  &ensp;<b>เวลา</b> {detail?.createAt.substring(11, 19)}
                </>
              )}
            </p>
          </div>

          <div className="maintenanceInform-content-contact">
            {contactDetail()}
          </div>

          <div className="maintenanceInform-content-type">{deviceType()}</div>

          <div className="maintenanceInform-content-contact">
            {maintenanceDetail()}
          </div>

          <p>
            <b>รายละเอียด/ปัญหาแจ้งซ่อม</b>&emsp;{detail?.topic}
          </p>

          <p>
            <b>ปริมาณการใช้งานเครื่องจักร(ต่อวัน/ต่อสัปดาห์/ต่อเดือน)</b>{" "}
            {detail[0]?.amountOfUse}&emsp;{detail?.amountOfUseUnit}
          </p>

          <p>
            <b>หมายเลขเอกสารเบิกจ่าย(กรอก)</b>&emsp;
          </p>

          <p>
            <b>หมายเหตุ:</b>&emsp;{detail?.note}
          </p>
          <div className="maintenanceInform-content-image"></div>
        </div>
      </Segment>
    </div>
  );
}
